import { render, staticRenderFns } from "./introducePageEight.vue?vue&type=template&id=c452be6e&scoped=true"
import script from "./introducePageEight.vue?vue&type=script&lang=js"
export * from "./introducePageEight.vue?vue&type=script&lang=js"
import style0 from "./introducePageEight.vue?vue&type=style&index=0&id=c452be6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c452be6e",
  null
  
)

export default component.exports